import {ActiveCustomType} from "finhelper";
import {CategoryText} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import Icon from "#app/interface/Icon";
import SearchCategory from "#app/pages/IncomeAndExpenses/components/BaseOperationList/form/SearchCategory";
import React from "react";

export const CategoryDisplay = ({ item, types, customTypeId }) => {
    const foundItem = ActiveCustomType.getItem(item, types, customTypeId);
    const icon = foundItem ? foundItem.icon : 'non_category.svg';
    const color = foundItem ? foundItem.color : null;

    let category_text = item.category_text;

    if (category_text.length > 15)
    {
        category_text = category_text.slice(0, 14) + '...';
    }

    let category = <CategoryText>{icon ? <Icon src={icon} color={color}/> : ''} {category_text}</CategoryText>

    return item.editable ? (
        <SearchCategory item={item} categoryText={category} types={types} customTypeId={customTypeId}/>
    ) : (
        <CategoryText>
            {category}
        </CategoryText>
    );
};